// import {cleanInputs} from '@/js/components/forms/clean_inputs'
export function cleanInputs(form) {
    const ins = form.querySelectorAll('input, textarea')
    ins.forEach(i => {
        i.value = ''
    });
}